import type { TypographyToken } from '@elfsight/widget-ui';
import { Typography } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { INVALID_VALUE_DASH } from '../../../common';

type InvalidPriceProps = {
  componentName: string;
  textToken?: TypographyToken;
};

export function InvalidPrice({
  componentName,
  textToken = 'text16'
}: InvalidPriceProps) {
  return (
    <Typography
      textToken={textToken}
      className={createReadableClass({
        component: componentName,
        element: 'price',
        modifier: 'invalid'
      })}
    >
      {INVALID_VALUE_DASH}
    </Typography>
  );
}
